export enum PaymentStatus {
    Pending = 'PENDING',
    Completed = 'COMPLETED',
    Failed = 'FAILED',
    Canceled = 'CANCELED',
}

export const PaymentStatusLabels = {
    [PaymentStatus.Pending]: 'Ожидание оплаты',
    [PaymentStatus.Completed]: 'Оплачено',
    [PaymentStatus.Failed]: 'Ошибка оплаты',
    [PaymentStatus.Canceled]: 'Платеж отменен',
} as { [key in PaymentStatus]: string }

export enum PaymentMethodName {
    Cash = 'CASH',
    Certificate = 'CERTIFICATE',
    Account = 'ACCOUNT',
    OnlineCloudPayments = 'ONLINE_CLOUDPAYMENTS',
    OnlineYookassa = 'ONLINE_YOOKASSA',
}

export const PaymentMethodLabels = {
    [PaymentMethodName.Cash]: 'Наличными',
    [PaymentMethodName.Certificate]: 'Сертификат',
    [PaymentMethodName.OnlineCloudPayments]: 'Онлайн CloudPayments',
    [PaymentMethodName.OnlineYookassa]: 'Онлайн Yookassa',
    [PaymentMethodName.Account]: 'Счет на оплату',
} as { [key in PaymentMethodName]: string }

export type PaymentStatusType =
    (typeof PaymentStatus)[keyof typeof PaymentStatus]

export type PaymentMethodType =
    (typeof PaymentMethodName)[keyof typeof PaymentMethodName]
